import React, { Fragment } from "react";
import PropTypes from "prop-types";
import PilotFaq from "../pilot-faq";
import { NUMBER } from "../../../constants/app-constants";
import styles from "./styles.css";

const FranchiseFaqs = ({
    faqList
}) => {

    return (
        <Fragment>
            {faqList && faqList.length > NUMBER.ZERO &&
                <div styleName={"styles.faqWrapper"}>
                    <PilotFaq
                        heading="Frequently asked questions"
                        faqs={faqList}
                        attachSchema={true}
                    />
                </div>
            }
        </Fragment>
    );
};

FranchiseFaqs.propTypes = {
    faqList: PropTypes.array
};

export default FranchiseFaqs;
